import { Formik, FormikProps } from 'formik';
import React from 'react';
import TextInput from '@components/app/form/TextInput';
import FormElement from '@components/presentational/Form/FormElement';
import { Box, Button, useToast, VStack } from '@chakra-ui/react';
import { requestResetPassword } from '@/api/user';
import { ApiException } from '@/types/exception/ApiException';
import { useRouter } from 'next/router';

interface FormValues {
  email: string;
}

function FormikForm({
  submitCount,
  isValid,
  isValidating,
  isSubmitting,
  errors,
  handleSubmit,
  values,
}: FormikProps<FormValues>) {
  return (
    <form
      onSubmit={evt => {
        evt.preventDefault();
        handleSubmit(evt);
      }}
      noValidate
    >
      <VStack spacing="1rem" align="stretch">
        <TextInput
          name={'email'}
          label={'Adresse email'}
          type={'email'}
          required
        />
        <Box ml={{ md: 'auto' }} mt=".5rem" order={{ md: 2 }}>
          <FormElement
            label="Réinitialiser mon mot de passe"
            isLabelVisuallyHidden
          >
            <Button size="sm" type={'submit'} isLoading={isSubmitting}>
              Réinitialiser mon mot de passe
            </Button>
          </FormElement>
        </Box>
      </VStack>
    </form>
  );
}

export default function ResetPasswordForm({}) {
  const toast = useToast();

  const initialValues: FormValues = {
    email: '',
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, formActions) => {
        let response: Response;

        try {
          response = await requestResetPassword(values.email);
        } catch (err) {
          formActions.setSubmitting(false);
          return;
        }

        if (response.ok) {
          toast({
            title:
              "Vous allez recevoir un email contenant un lien de connexion temporaire. Ce lien vous permettra de modifier votre mot de passe. Si vous ne recevez pas cet email, pensez à regarder dans vos courriers indésirables. Il se peut également que l'adresse email saisie ne corresponde pas à celle utilisée pour votre inscription",
            status: 'success',
            duration: 9000,
            isClosable: true,
          });
        }

        if (
          response.status === 400 &&
          response.headers.get('Content-Type') === 'json+exception'
        ) {
          const exception: ApiException = await response.json();
          let message = 'Une erreur est survenue';

          const errorsMaps = {
            ResetTokenAlreadyRequestedException:
              'Vous avez déja demandé une réinitialisation de mot de passe il y a moins de 24 heures',
            ResetPasswordRequestForUnfinishedSignUpException:
              'Une inscription incomplète à IFprofs existe pour votre adresse mail. Si vous ne vous souvenez plus du mot de passe associé, nous vous invitons à reprendre votre inscription au début.',
          };

          if (exception.exception.className in errorsMaps) {
            message = errorsMaps[exception.exception.className];
          }

          toast({
            title: message,
            status: 'error',
            duration: 9000,
            isClosable: true,
          });
        }

        formActions.setSubmitting(false);
        return;
      }}
    >
      {formProps => {
        return <FormikForm {...formProps} />;
      }}
    </Formik>
  );
}
